import React, { useContext, useEffect, useState } from 'react'
import makeStyles from "@material-ui/core/styles/makeStyles";
import Grid from "@material-ui/core/Grid";
import { Dialog, DialogContent, DialogTitle, MenuItem } from "@material-ui/core";
import MROTextField from "components/form_components/TextField";
import MROButton from 'components/buttons';
import { Typography } from "@material-ui/core";
import WorkshopReportService from "lib/services/api/accounts/workshop";
import { ToastMessageContext } from "lib/contexts/message_context";
import moment from 'moment';
import DateField from './DateField';
import { getOrganisationId } from 'lib/utils/common_utils';
import { validateFormData } from 'lib/utils/helperFunctions';




const useStyles = makeStyles((theme) => ({
  formWrapper: {
    background: "#fff",
    width: "100%",
  },
  title: {
    display: "flex",
    justifyContent: "center",
    "& h2": {
      //   color: theme.palette.primary.main,
      fontSize: "40px",
      fontWeight: 40,
    },
  },
  subTitle: {
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "20px",
    color: "#4D4F5C",
  },
  card: {
    padding: "0 25px",
  },
  actionButtons: {
    paddingTop: "20px",
    paddingBottom: "33px",
    textAlign: "center",
    "& button:not(:last-child)": {
      marginRight: "20px",
    },
  },
  purchaseGrid: {
    paddingTop: "0 !important",
    paddingBottom: "0 !important",
    height: "85px",
  },
  purchaseStock: {
    marginBottom: "20px",
    maxWidth: "350px",
  },
}));

function InvoiceRecord(props) {
  const { handleClose,
    financeOrderList,
    orderType,
    currentSelectedInvoice,
    action,
    type,
    remaining, invoiceDetails
  } = props;

  const classes = useStyles();
  const [errors, setErrors] = useState({});
  const message = useContext(ToastMessageContext);
  const user = JSON.parse(sessionStorage.getItem("user"));
  const [netValue, setNetValue] = useState("")
  const [invoiced, setInvoiced] = useState(false)
  const [remain, setRemain] = useState(0)
  const [dueDate, setDueDate] = useState("")
  const [loading, setLoading] = useState(false)
  const [typeInvoice, setTypeInvoice] = useState("")
  let today = moment().format("YYYY-MM-DD")





  useEffect(() => {
    if (action === "create" && orderType !== "Storage") {
      if (typeInvoice === "invoice") {
        setNetValue(remain ?? "")
      } else {
        setNetValue("")
      }

    }


  }, [remain, typeInvoice])

  useEffect(() => {
    if (action === "UpdateInvoice") {
      let invoice = currentSelectedInvoice.type === 0 ? "invoice" : currentSelectedInvoice?.type === 1 ? "credit" : ""
      setTypeInvoice(invoice)
      setNetValue(currentSelectedInvoice.net_value ?? "")
      setInvoiced("")
      setDueDate(currentSelectedInvoice?.due_date)

    }
  }, [currentSelectedInvoice])
  useEffect(() => {
    if (action === "create") {

      let format_date = moment(today, "YYYY-MM-DD").format("DD/MM/YYYY")
      if (invoiceDetails?.payment_term_days != null) {
        handleDueDate(format_date)
      }
    }
  }, [action])


  useEffect(() => {

    if (remaining) {
      setRemain(Math.abs(remaining))
    }
  }, [remaining])



  useEffect(() => {
    if (netValue !== undefined && netValue !== null) {
      let total_invoice = invoiceDetails?.total_invoiced ?? 0
      const jobValue = parseFloat(total_invoice) + parseFloat(remaining);

      let newValue = parseFloat(netValue);
      let newSign = typeInvoice === "credit" ? -1 : +1;

      let newTotalInvoiced;

      if (currentSelectedInvoice?.id) {
        // Editing an existing record
        const oldValue = parseFloat(currentSelectedInvoice.net_value);
        const oldSign = currentSelectedInvoice.type === 1 ? -1 : +1;
        newTotalInvoiced = parseFloat(total_invoice) - oldValue * oldSign + newValue * newSign;
      } else {
        // Adding new
        newTotalInvoiced = parseFloat(total_invoice) + newValue * newSign;
      }

      const newRemaining = jobValue - newTotalInvoiced;
      console.log("newRemaining====", newRemaining)
      if (newRemaining === 0) {
        setInvoiced(true);
      } else {
        setInvoiced(false);
      }
    }
  }, [netValue, typeInvoice, currentSelectedInvoice]);
















  const handleSubmit = async (e) => {

    e.preventDefault()
    const formdata = new FormData(e.target)

    const { error, valid } = validateFormData(formdata)




    if (!valid) {
      setErrors(error);
      return;
    }

    formdata.append("reportable_id", financeOrderList.id)
    formdata.append("workshop_order_id", financeOrderList.id)
    formdata.append("order_type", orderType)
    formdata.append("user_id", user?.id);
    formdata.append("reportable_type", type);
    formdata.append("organisation_id", getOrganisationId());
    formdata.append("invoiced", invoiced);
    formdata.append("currency_id", invoiceDetails.currency_id);
    formdata.append("sales_rate", invoiceDetails.sales_rate);
    formdata.append("base_station_id", invoiceDetails.base_station_id);
    formdata.append("line_customer_id", invoiceDetails.line_customer_id);
    // formdata.set("invoice_date", moment(date).format("YYYY-MM-DD"))
    setLoading(true)

    const isCreate = action === "create";
    const serviceCall = isCreate ? WorkshopReportService.createInvoice(formdata)
      : WorkshopReportService.updateInvoice(formdata, currentSelectedInvoice?.id);



    try {
      const response = await serviceCall;

      if (response?.success) {
        message.showToastMessage({
          message: isCreate
            ? "Invoice Created successfully."
            : "Invoice Updated successfully.",
          variant: "success",
        });
        handleClose(response);
      } else {
        handleError(response);
      }
    } catch (error) {
      handleError(error, true);
    } finally {
      setLoading(false);
    }
  }
  const handleError = (res, closeOnError = false) => {
    handleClose(closeOnError || true);
    message.showToastMessage({
      message:
        res?.error && Array.isArray(res?.error)
          ? res?.error.join(", ")
          : "Something went wrong. Try again!",
      variant: "error",
    });
  };

  const handleDueDate = (date) => {

    if (date !== "Invalid date") {
      const value = moment(date, "DD/MM/YYYY").add(invoiceDetails?.payment_term_days, "days").format("YYYY-MM-DD")

      setDueDate(value)

    }

  }


  return (
    <div>
      <Dialog
        maxWidth={"sm"}
        open={true}
        className={classes.modal}
        onClose={handleClose}
        aria-labelledby="base-station-manage"
      >
        <DialogTitle>
          <Typography
            color="primary"
            className={classes.title}
          >
            Invoice Record
          </Typography>
        </DialogTitle>
        <DialogContent className={classes.card}>
          <div className={classes.formWrapper}>
            <form spellcheck="false" onSubmit={handleSubmit}>
              <Grid
                className={classes.purchaseStock}
                container
                spacing={1}
                alignItems={"center"}
                justify={"flex-start"}
              >
                <Grid className={classes.purchaseGrid} item xs={12}>


                  <MROTextField
                    name={"type"}
                    label={"Type*"}
                    select

                    value={typeInvoice}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ maxLength: 30 }}
                    placeholder="Invoice Number"
                    error={errors.type}
                    helperText={errors.type ? "*please select Type *" : null}
                    onChange={(e) => {
                      console.log("e.target.value", e.target.value)
                      setTypeInvoice(e.target.value)
                      setErrors({ ...errors, invoice_number: false });
                    }}

                  >
                    <MenuItem value={"invoice"}>Invoice</MenuItem>
                    <MenuItem value={"credit"}>Credit Note</MenuItem>
                  </MROTextField>







                </Grid>
                <Grid className={classes.purchaseGrid} item xs={12}>
                  <MROTextField
                    name={"invoice_number"}
                    label={"Reference # *"}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ maxLength: 30 }}
                    placeholder="Invoice / Credit Note # *"
                    error={errors.invoice_number}
                    helperText={errors.invoice_number ? "*please enter a invoice number" : null}
                    onChange={(e) => { setErrors({ ...errors, invoice_number: false }); }}
                    defaultValue={currentSelectedInvoice ? currentSelectedInvoice.invoice_number : ""}
                  >

                  </MROTextField>
                </Grid>
                <Grid className={classes.purchaseGrid} item xs={12}>
                  <MROTextField
                    name={"net_value"}
                    label={"Value (Net) *"}
                    InputLabelProps={{ shrink: true }}
                    error={errors.net_value || errors.net_value_greater || errors.net_value_invoice}
                    placeholder="Net Value"
                    value={netValue}
                    helperText={errors.net_value ? "*please enter value" : errors.net_value_greater ? "Can't be greater than remaining" : errors.net_value_invoice ? "Cannot exceed current value and remaining" : null}
                    onChange={(e) => {
                      let val = e.target.value
                      if (isNaN(val)) {
                        val = val.replace(/[^0-9\.]/g, "");
                        if (val.split(".").length > 2)
                          val = val.replace(/\.+$/, "");
                      }
                      setNetValue(val)
                      setErrors({ ...errors, net_value_greater: false, net_value: false, net_value_invoice: false })


                    }}
                    defaultValue={currentSelectedInvoice ? currentSelectedInvoice.net_value : ""}
                  />
                </Grid>
                <Grid className={classes.purchaseGrid} item xs={12}>
                  <DateField
                    required
                    name="invoice_date"
                    label={"Issued Date  *"}
                    InputLabelProps={{ shrink: true }}
                    error={errors.invoice_date}
                    helperText={errors.invoice_date ? "*please enter a date" : null}
                    onChange={(e) => {
                      handleDueDate(e)
                      setErrors({ ...errors, invoice_date: false });
                    }}
                    defaultValue={currentSelectedInvoice ? currentSelectedInvoice.invoice_date : today}

                  />
                </Grid>
                <Grid className={classes.purchaseGrid} item xs={12}>
                  <DateField
                    required
                    name="due_date"
                    label={"Due Date *"}
                    value={dueDate}
                    type={"due"}
                    InputLabelProps={{ shrink: true }}
                    error={errors.invoice_date}
                    helperText={errors.invoice_date ? "*please enter due date" : null}
                    onChange={(e) => {
                      if (e !== "Invalid date") {
                        const value = moment(e, "DD/MM/YYYY").format("YYYY-MM-DD")

                        setDueDate(value)


                      } else {
                        setDueDate("")
                      }

                      setErrors({ ...errors, due_date: false });
                    }}
                    defaultValue={currentSelectedInvoice ? currentSelectedInvoice.due_date : ""}

                  />

                </Grid>
                <Typography color='primary' style={{ fontStyle: "italic", fontSize: "12px", marginTop: "-12px", paddingLeft: "11px" }}>Payment Terms (Days):{invoiceDetails?.payment_term_days} </Typography>
                {orderType === "Storage" && <Grid className={classes.purchaseGrid} item xs={12} style={{ marginTop: "10px" }}>
                  <DateField
                    required
                    name="next_due_date"
                    label={"Next Invoice Due *"}
                    InputLabelProps={{ shrink: true }}
                    error={errors.next_due_date}
                    helperText={errors.next_due_date ? "*please enter a date" : null}
                    onChange={(e) => { setErrors({ ...errors, next_due_date: false }); }}
                    defaultValue={currentSelectedInvoice ? currentSelectedInvoice.next_due_date : ""}
                  />
                </Grid>}
              </Grid>
              <div className={classes.actionButtons}>
                <MROButton
                  //   disabled={loading}
                  type="button"
                  variant={"contained"}
                  onClick={handleClose}
                >
                  Cancel
                </MROButton>
                <MROButton
                  loading={loading}
                  type="submit"
                  variant={"contained"}
                  color="primary"
                >
                  {action === "create" ? "Complete" : "Update"}
                </MROButton>
              </div>
            </form>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default InvoiceRecord;
